import { Injectable } from '@angular/core';
import { HttpService } from '../../http.service';
import { PaymentgetwayService } from '../..';

@Injectable({
  providedIn: 'root'
})
export class NetbankingPaymentService {

  constructor(private http: HttpService, private PAYMENT_TYPE: PaymentgetwayService) { }

  makePayment(NETBANKING_INFO: any, TANX_ID: any) {
    const NETBANKING_DATA = NETBANKING_INFO?.net_banking_value;
    const PAYMENT_TYPE = this.PAYMENT_TYPE?.InternetBanking
    // console.log(NETBANKING_DATA, this.PAYMENT_TYPE?.InternetBanking);
    const body = new URLSearchParams();
    body.set("id", TANX_ID);
    body.set("netbanking[net_banking]", NETBANKING_DATA.code);
    body.set("netbanking[payOption]", PAYMENT_TYPE.internet_pay_Option);
    body.set("payment[payment_type]", PAYMENT_TYPE.internet_payment_type);
    body.set("payment[value][net_banking]", NETBANKING_DATA.code);
    body.set("payment[value][payOption]", PAYMENT_TYPE.internet_pay_Option);
    body.set("is_api_payment", 'true');

    return this.http.flightsave('b2c/booking/payment', body);
  }
}
